<template>
  <div class="jisaoSearch">
    <van-search
      v-model="keyValue"
      show-action
      placeholder="姓名 如：李四 或 编号 如：88888888"
      @search="onSearch"
      style="border: 0.5px solid #73c7a0;border-radius: 32px;height:40px;"
    >
      <template #action> </template>
    </van-search>
    <div class="btn" @click="onSearch">搜索</div>
  </div>
</template>

<script>
import bus from '../../common/bus'
export default {
  name: 'jisaoSearch',
  data() {
    return {
      keyValue: localStorage.getItem('keyword') ? localStorage.getItem('keyword') : '',
    }
  },
  created() {
    localStorage.setItem('keyword', this.keyValue)
    if (localStorage.getItem('keyword')) {
      this.keyValue = localStorage.getItem('keyword')
    }
  },
  methods: {
    onSearch() {
      localStorage.setItem('keyword', this.keyValue)
      let _url = this.$route.fullPath

      if (_url == '/jisao/list/') {
        bus.$emit('keyword', '')
      } else {
        this.$router.push({ path: '/jisao/list/' })
      }
    },
  },
}
</script>

<style>
.jisaoSearch .btn {
  border-radius: 2500px;
  color: #fff;
  background-image: none;
  background-color: #73c7a0;
  position: relative;
  border: 0px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 14px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  text-decoration: none;
  overflow: visible;
  margin-left: 5px;
  -webkit-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
  margin-right: 0;
}
.jisaoSearch .van-search__content {
  background: unset;
}
.jisaoSearch .van-search {
  width: 80%;
}
.jisaoSearch {
  width: 95%;
  margin: 25px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
